import { h } from 'vue';

// Counts rendered in live overview tables: zero stays visible but muted.
export const renderLiveCount = cellProps => {
  const value = Number(cellProps.getValue() || 0);
  return h(
    'span',
    {
      class: value ? 'font-medium text-n-slate-12' : 'text-n-slate-10',
    },
    value.toLocaleString()
  );
};

// Busiest rows first; ties ordered alphabetically by name.
export const sortByOpenThenName = (a, b) => {
  const openDiff = b.open - a.open;
  if (openDiff === 0) {
    return a.agent.localeCompare(b.agent);
  }
  return openDiff;
};
